import { sanitizeString } from '../../../../assets/js/text-renderer';
import './blog-card.scss';

const getCard = (data) => `<article class="blog-card">
  <img
    class="img-fluid"
    src="${data.img}"
    alt="${data.title}"
  />
  <section class="blog-card__data">
    <div class="blog-card__tags">
      ${data.tags}
    </div>
    <a href="/blog/blog-entry/?key=${data.name}">
      <h4>${data.title}</h4>
    </a>
    <p>${data.author} / ${data.date}</p>
  </section>
</article>`;

/**
 * Custom Blog Card Web Component
 *
 * This component renders a blog card with an image, title, author, date, and tags.
 *
 * Attributes:
 *
 * Required:
 * - title: Sets the title of the blog post.
 * - img: Sets the image URL for the blog post.
 * - name: Sets the entry name for the blog post.
 * - author: Sets the author of the blog post. Defaults to "Author".
 * - date: Sets the date of the blog post. Defaults to "Date".
 *
 * Optional:
 * - tags: Sets the tags for the blog post, separated by commas.
 *
 * Example:
 * <custom-blog-card
 *   title="Blog Post Title"
 *   img="https://example.com/image.jpg"
 *   name="blog-post-title"
 *   author="John Doe"
 *   date="2023-01-01"
 *   tags="tag1,tag2,tag3">
 * </custom-blog-card>
 */
class BlogCard extends HTMLElement {
  connectedCallback() {
    if (
      DEVELOPMENT || (
      window['__PRERENDER_INJECTED'] && 
      window['__PRERENDER_INJECTED'].render_text)
    ) this.render();
  }

  render() {
    const data = {
      author: sanitizeString(this.getAttribute('author')),
      date: sanitizeString(this.getAttribute('date')),
      img: sanitizeString(this.getAttribute('img')),
      name: sanitizeString(this.getAttribute('name')),
      tags: this.getTags(),
      title: sanitizeString(this.getAttribute('title')),
    };

    this.innerHTML = getCard(data);
  }

  getTags() {
    const tags = this.getAttribute('tags');
    return tags
      ? tags
          .split(',')
          .map((tag) => `<span class="tag">${sanitizeString(tag)}</span>`)
          .join('')
      : '';
  }
}

customElements.define('custom-blog-card', BlogCard);
